import {ResolveFn} from '@angular/router';
import {inject} from "@angular/core";
import {PageService} from "./page.service";

export const pageResolver: ResolveFn<any> = (route, state) => {
    return inject(PageService).getPageById(parseInt(route.paramMap.get('id')) ?? null);
};
